<!-- 影片详情 -->
<template>
  <div v-show="showContent">
    <van-nav-bar
        title="电影详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="top">
      <div class="header">
        <div class="header-bg" :style="{background:`url(${filmInfo.poster})`}" v-if="filmInfo.poster"></div>
        <div>
<!--          <u--image :src="filmInfo.poster" mode="aspectFit" width="208rpx" height="300rpx"></u--image>-->
          <van-image
              fit="aspectFill"
              :src="filmInfo.poster"
              class="header-img"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>

        <div class="header-content">
          <div class="title">{{filmInfo.name}}</div>
          <div>{{filmInfo.country}}/{{filmInfo.language}}/{{filmInfo.duration}}分钟</div>
          <div>{{filmInfo.opentime}}上映</div>
          <div>导演：{{filmInfo.director}}</div>
          <div>{{filmInfo.type}}</div>
          <div class="mark">{{filmInfo.version_types}}</div>
        </div>
      </div>

      <div class="intro">
          <div class="title">简介：</div>
        {{filmInfo.description}}
      </div>
    </div>

    <div class="middle">
      <div class="title">演职人员</div>
      <div class="photoList">
        <div v-for="item in actorList" :key="item" class="photo">
<!--          <u--image :src="item.avatar" mode="aspectFit" width="208rpx" height="300rpx"></u--image>-->
          <van-image
              fit="aspectFit"
              :src="item.avatar"
              class="photo-img"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <div style="text-align: center;">{{item.name || item.act_name}}</div>
        </div>
          <div style="text-align: center;" v-if="filmInfo.leadingRole">{{filmInfo.leadingRole }}</div>
      </div>
    </div>
    <div class="middle last">
      <div class="title">视频和剧照</div>
      <div class="photoList">
        <div v-for="item in photoList" :key="item" class="photo">
<!--          <u--image :src="item" mode="aspectFit" width="300rpx" height="208rpx"></u--image>-->
          <van-image
              fit="aspectFit"
              :src="item"
              class="photo-img"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="foot-btn" @click="toBuy">特惠购票</div>
    </div>
  </div>
</template>

<script>
import {getMovieInfo} from '@/api/cinema'
export default {
  name: "filmDetail",
  components: {},
  props: {},
  data() {
    return {
      showContent: false,
      filmInfo: {
        poster: '',
        name: '',
        grade: '',
        country: '',
        language: '',
        duration: '',
        opentime: '',
        director: '',
        type: '',
        version_types: '',
        description: '',
        actorList: [],
        imgList: [],
        showversionList: {string:[]},
          leadingRole:'',
      },
      photoList:[], // 剧照表
      actorList: [], // 演职人员表
      movieId: '',
    }
  },
  methods: {
    getFilmInfo() {
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      getMovieInfo({
        movieId:this.movieId,
        city_id:this.cityId
      }).then(res=>{
        if(res?.data?.film_info?.showversion){
          res.data.film_info.showversionList = JSON.parse(res.data.film_info.showversion) || {string:[]}
          if(res.data.film_info?.showversionList?.string?.length){
            res.data.film_info.version_types = res.data.film_info.showversionList.string.join('，')
          }
        }else{
          res.data.film_info.version_types = ''
        }
        if(res?.data?.film_info?.actorList){
          res.data.film_info.actorList = JSON.parse(res.data.film_info.actorList)
        }
        if(res?.data?.film_info?.trailerlist){
          res.data.film_info.imgList = res.data.film_info.trailerlist.split(',')
        }

        this.filmInfo = res?.data?.film_info || {}
        let actorList = []
        if(this.filmInfo?.actorList){
          actorList.push.apply(actorList,this.filmInfo.actorList)
        }
        this.actorList = actorList
        if(this.filmInfo?.imgList){
          this.photoList = this.filmInfo.imgList
        }
        this.showContent = true
      }).catch(e=>{
        console.log(e)
      }).finally(()=>{
        this.$Toast.clear()
      })
    },
    toBuy(){
      this.$router.push({
        path:'/cinemaList',
        query:{
          movieId:this.filmInfo.movieId,
          cityId:this.cityId
        }
      })
    },
    onClickLeft(){
      this.$router.back()
    }
  },
  created() {
    this.movieId = this.$route.query.movieId
    this.getFilmInfo()
  },
  mounted() {

  },
  computed: {
    cityName(){
      return this.$store.state.city.cityName
    },
    cityId(){
      let id = ''
      if(this.cityList.length && this.cityName){
        this.cityList.map(item=>{
          if(item.cityName === this.cityName){
            id = item.cityCode
          }
        })
      }
      return id
    },
    cityList(){
      return this.$store.state.cinema.cityList
    },
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.top {
  background-color: #ffffff;
  position: relative;
  z-index: 0;
  padding-bottom:20px;
}

.header {
  width: 100%;
  height: 372px;
  display: flex;
  position: relative;
  align-items: center;

  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    overflow: hidden;
    -webkit-filter: blur(.3rem) brightness(0.5);
    filter: blur(.3rem) brightness(0.5);
    background-size: cover;
    background-repeat: no-repeat;
    opacity: .55;
    background-position: 0 50% !important;
  }

  .header-img {
    z-index: 100;
    margin-left: 30px;
    align-self: center;
    width:200px;
    height:300px;
    border-radius: 26px;
    overflow: hidden;
  }

  .header-content {
    align-self: center;
    color: #ffffff;
    margin-left: 30px;
    font-size: 24px;

    &>div {
      line-height: 1.7;
    }

    .title {
      font-size: 40px;
    }

    .mark {
      box-sizing: border-box;
      position: relative;
      display: inline-flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      line-height: normal;
      margin-right: 6px;
      margin-left: -6px;
      padding: 0 6px;
      border: 1px solid #b7acac;
      border-radius: 2.5px;
      //height: 15px;
      color: #d4d6e3;
      font-size: 20px;
      font-family: fantasy;
    }
  }
}

.intro {
  margin: 30px;
    .title{
        font-size:34px;
        margin-bottom:20px;
    }
}
.middle{
  margin:30px 0;
  background-color: #ffffff;
  padding:30px;
  .title{
    font-size:34px;
    margin-bottom:20px;
  }
}
.last{
  padding-bottom: 160px;
}
.photoList{
  overflow-x: auto;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  .photo{
    margin-right:20px;
  }
}
.photo-img{
  width:200px;
  height:300px;
}
.foot{
  position: fixed;
  bottom: 0;
  padding:20px;
  width:100%;
  background-color: #ffffff;
  .foot-btn{
    text-align: center;
    line-height: 80px;
    background-color: #3c9cff;
    color: #ffffff;
    border-radius: 20px;
  }
}
</style>
